export default "__VITE_ASSET__B$kHHbQH__"